import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  TArchiveAllTicketValidation,
  ArchiveAllTicketValidationSchema,
  useArchiveAllTicketMutation,
} from '../../../api/archive-all-ticket.api';
import { useCustomToast } from '@/hooks/use-custom-toast';
import { axiosExtractErrorMessage, AxiosErrorCustom } from '@/lib/axios';

import {
  GET_LIST_TICKET_BY_SPACE_QUERY_KEY,
  TGetListTicketBySpaceResponse,
} from '../../../api/get-ticket-by-space.api';
import {
  GET_LIST_ARCHIVE_TICKET_BY_SPACE_QUERY_KEY,
  TGetListArchiveTicketBySpaceResponse,
} from '../../../api/get-archive-ticket-by-space.api';
import { useTicketingModalRootActions } from '@/features/ticketings/_shared/components/ticketing-modal-root/ticketing-modal-root.store';
import { spaceUpdateWebsocketStore } from '@/features/ticketings/_shared/websockets/space-update-websocket.store';
import { TTicketBySpace } from '../../../types/ticket.type';

const COLUMN_ARCHIVE_TIMEOUT = 800;

export interface IArchiveAllTicketModalProps {
  spaceId: string;
  spaceColumnId: string;
  onSuccess?: () => Promise<void> | void;
}

interface IArchiveAllTicketOptimisticContext {
  previousActiveData?: TGetListTicketBySpaceResponse;
  previousArchiveData?: TGetListArchiveTicketBySpaceResponse;
  archivedTickets?: TTicketBySpace['tickets'];
  archivedColumn?: TTicketBySpace;
}

export function useArchiveAllTicketModal({ spaceId, spaceColumnId, onSuccess }: IArchiveAllTicketModalProps) {
  // HOOKS
  const showToast = useCustomToast();
  const modalActions = useTicketingModalRootActions();

  // Ref to track timeout for cleanup
  const closeModalTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const activeQueryKey = [GET_LIST_TICKET_BY_SPACE_QUERY_KEY, { spaceId }];
  const archiveQueryKey = [GET_LIST_ARCHIVE_TICKET_BY_SPACE_QUERY_KEY, { spaceId }];

  const mutationArchiveAllTicket = useArchiveAllTicketMutation({
    mutationConfig: {
      onMutate: async (variables: TArchiveAllTicketValidation): Promise<void> => {
        // Set archiving state for this column
        const { actions } = spaceUpdateWebsocketStore.getState();
        actions.setColumnOperation(variables.spaceColumnId, 'archiving');

        // // Cancel any outgoing refetches to avoid overwriting optimistic update
        // await Promise.all([
        //   queryClient.cancelQueries({ queryKey: activeQueryKey }),
        //   queryClient.cancelQueries({ queryKey: archiveQueryKey }),
        // ]);

        // // Snapshot the previous values for rollback
        // const previousActiveData = queryClient.getQueryData<TGetListTicketBySpaceResponse>(activeQueryKey);
        // const previousArchiveData = queryClient.getQueryData<TGetListArchiveTicketBySpaceResponse>(archiveQueryKey);

        // // Find the column and get all tickets
        // let archivedTickets: TTicketBySpace['tickets'] | undefined;
        // let archivedColumn: TTicketBySpace | undefined;

        // if (previousActiveData?.payload) {
        //   const targetColumn = previousActiveData.payload.find((col) => col.spaceColumnId === spaceColumnId);
        //   if (targetColumn) {
        //     archivedTickets = targetColumn.tickets || [];
        //     archivedColumn = {
        //       spaceColumnId: targetColumn.spaceColumnId,
        //       name: targetColumn.name,
        //       columnIndex: targetColumn.columnIndex,
        //       color: targetColumn.color,
        //       tickets: [],
        //     };
        //   }
        // }

        // // Optimistically remove all tickets from active list
        // if (previousActiveData?.payload && archivedTickets && archivedColumn) {
        //   queryClient.setQueryData<TGetListTicketBySpaceResponse>(activeQueryKey, (old) => {
        //     if (!old?.payload) return old;

        //     return {
        //       ...old,
        //       payload: old.payload.map((column) => {
        //         if (column.spaceColumnId === spaceColumnId) {
        //           return {
        //             ...column,
        //             tickets: [],
        //           };
        //         }
        //         return column;
        //       }),
        //     };
        //   });
        // }

        // // Optimistically add all tickets to archive list
        // if (previousArchiveData?.payload && archivedTickets && archivedColumn) {
        //   queryClient.setQueryData<TGetListArchiveTicketBySpaceResponse>(archiveQueryKey, (old) => {
        //     if (!old?.payload) return old;

        //     // Check if the archive column already exists
        //     const existingArchiveColumnIndex = old.payload.findIndex((col) => col.spaceColumnId === spaceColumnId);

        //     if (existingArchiveColumnIndex >= 0) {
        //       // Column exists, add tickets to it
        //       const newPayload = [...old.payload];
        //       const sortedTickets = sortTicketsByPosition(archivedTickets);
        //       newPayload[existingArchiveColumnIndex] = {
        //         ...newPayload[existingArchiveColumnIndex],
        //         tickets: [...(newPayload[existingArchiveColumnIndex].tickets || []), ...sortedTickets],
        //       };
        //       return {
        //         ...old,
        //         payload: newPayload,
        //       };
        //     } else {
        //       // Column doesn't exist, create it with all tickets
        //       const sortedTickets = sortTicketsByPosition(archivedTickets);
        //       return {
        //         ...old,
        //         payload: [
        //           ...old.payload,
        //           {
        //             ...archivedColumn,
        //             tickets: sortedTickets,
        //           },
        //         ],
        //       };
        //     }
        //   });
        // }

        // return {
        //   previousActiveData,
        //   previousArchiveData,
        //   archivedTickets,
        //   archivedColumn,
        // };
      },
      //   // Cancel any outgoing refetches to avoid overwriting optimistic update
      //   await Promise.all([
      //     queryClient.cancelQueries({ queryKey: activeQueryKey }),
      //     queryClient.cancelQueries({ queryKey: archiveQueryKey }),
      //   ]);

      //   // Snapshot the previous values for rollback
      //   const previousActiveData = queryClient.getQueryData<TGetListTicketBySpaceResponse>(activeQueryKey);
      //   const previousArchiveData = queryClient.getQueryData<TGetListArchiveTicketBySpaceResponse>(archiveQueryKey);

      //   // Find the column and get all tickets
      //   let archivedTickets: TTicketBySpace['tickets'] | undefined;
      //   let archivedColumn: TTicketBySpace | undefined;

      //   if (previousActiveData?.payload) {
      //     const targetColumn = previousActiveData.payload.find((col) => col.spaceColumnId === spaceColumnId);
      //     if (targetColumn) {
      //       archivedTickets = targetColumn.tickets || [];
      //       archivedColumn = {
      //         spaceColumnId: targetColumn.spaceColumnId,
      //         name: targetColumn.name,
      //         columnIndex: targetColumn.columnIndex,
      //         color: targetColumn.color,
      //         tickets: [],
      //       };
      //     }
      //   }

      //   // Optimistically remove all tickets from active list
      //   if (previousActiveData?.payload && archivedTickets && archivedColumn) {
      //     queryClient.setQueryData<TGetListTicketBySpaceResponse>(activeQueryKey, (old) => {
      //       if (!old?.payload) return old;

      //       return {
      //         ...old,
      //         payload: old.payload.map((column) => {
      //           if (column.spaceColumnId === spaceColumnId) {
      //             return {
      //               ...column,
      //               tickets: [],
      //             };
      //           }
      //           return column;
      //         }),
      //       };
      //     });
      //   }

      //   // Optimistically add all tickets to archive list
      //   if (previousArchiveData?.payload && archivedTickets && archivedColumn) {
      //     queryClient.setQueryData<TGetListArchiveTicketBySpaceResponse>(archiveQueryKey, (old) => {
      //       if (!old?.payload) return old;

      //       // Check if the archive column already exists
      //       const existingArchiveColumnIndex = old.payload.findIndex((col) => col.spaceColumnId === spaceColumnId);

      //       if (existingArchiveColumnIndex >= 0) {
      //         // Column exists, add tickets to it
      //         const newPayload = [...old.payload];
      //         newPayload[existingArchiveColumnIndex] = {
      //           ...newPayload[existingArchiveColumnIndex],
      //           tickets: [...(newPayload[existingArchiveColumnIndex].tickets || []), ...archivedTickets],
      //         };
      //         return {
      //           ...old,
      //           payload: newPayload,
      //         };
      //       } else {
      //         // Column doesn't exist, create it with all tickets
      //         return {
      //           ...old,
      //           payload: [
      //             ...old.payload,
      //             {
      //               ...archivedColumn,
      //               tickets: archivedTickets,
      //             },
      //           ],
      //         };
      //       }
      //     });
      //   }

      //   return {
      //     previousActiveData,
      //     previousArchiveData,
      //     archivedTickets,
      //     archivedColumn,
      //   };
      // },
      onError: (error: AxiosErrorCustom, variables: TArchiveAllTicketValidation, context: unknown) => {
        // Clear archiving state on error
        const { actions } = spaceUpdateWebsocketStore.getState();
        actions.clearColumnOperation(variables.spaceColumnId);

        const errorMessage = axiosExtractErrorMessage(error) || 'Error archive all tickets, please try again';
        showToast({ message: errorMessage, type: 'error' });

        // // Rollback to previous data on error
        // if (context && typeof context === 'object' && 'previousActiveData' in context) {
        //   const typedContext = context as IArchiveAllTicketOptimisticContext;
        //   if (typedContext.previousActiveData !== undefined) {
        //     queryClient.setQueryData(activeQueryKey, typedContext.previousActiveData);
        //   }
        //   if (typedContext.previousArchiveData !== undefined) {
        //     queryClient.setQueryData(archiveQueryKey, typedContext.previousArchiveData);
        //   }
        // }
      },
      onSuccess: async () => {
        showToast({ message: 'All tickets archived successfully!', type: 'success' });

        // Wait a bit before closing modal to ensure backend has processed the request
        // The socket listener will handle clearing the state after queries are invalidated
        await new Promise<void>((resolve) => {
          // Clear any existing timeout
          if (closeModalTimeoutRef.current) {
            clearTimeout(closeModalTimeoutRef.current);
          }

          // Set new timeout and store the ID for cleanup
          closeModalTimeoutRef.current = setTimeout(() => {
            // Check if modal is still open before closing
            if (modalActions.checkIsOpenModal('ArchiveAllTicketModal')) {
              modalActions.closeModal('ArchiveAllTicketModal');
              form.reset();

              // Call the onSuccess callback if provided
              if (onSuccess) {
                onSuccess();
              }
            }

            closeModalTimeoutRef.current = null;
            resolve();
          }, COLUMN_ARCHIVE_TIMEOUT);
        });

        // Note: We don't clear the column operation state here
        // The socket listener (handleColumnArchived) will clear it after
        // invalidating queries and ensuring data is fresh
      },
    },
  });

  const form = useForm<TArchiveAllTicketValidation>({
    resolver: zodResolver(ArchiveAllTicketValidationSchema),
    mode: 'onChange',
    defaultValues: {
      spaceColumnId: '',
    },
  });

  // HELPERS
  /*
    Separate loading form and loading mutation
   */
  const isOpen = useMemo(() => {
    return modalActions.checkIsOpenModal('ArchiveAllTicketModal');
  }, [modalActions]);

  const isDisabledForm = useMemo(() => {
    return mutationArchiveAllTicket.isPending || form.formState.isSubmitting;
  }, [mutationArchiveAllTicket, form.formState.isSubmitting]);

  const isLoadingForm = useMemo(() => {
    return mutationArchiveAllTicket.isPending || form.formState.isSubmitting;
  }, [mutationArchiveAllTicket, form.formState.isSubmitting]);

  // EFFECTS
  useEffect(() => {
    if (spaceColumnId) {
      form.reset({
        spaceColumnId: spaceColumnId,
      });
    }
  }, [spaceColumnId, form]);

  // Cleanup timeout on unmount or when modal closes
  useEffect(() => {
    return () => {
      if (closeModalTimeoutRef.current) {
        clearTimeout(closeModalTimeoutRef.current);
        closeModalTimeoutRef.current = null;
      }
    };
  }, []);

  // Cleanup timeout when modal closes
  useEffect(() => {
    if (!isOpen && closeModalTimeoutRef.current) {
      clearTimeout(closeModalTimeoutRef.current);
      closeModalTimeoutRef.current = null;
    }
  }, [isOpen]);

  // HANDLERS
  const handleCloseModal = useCallback(() => {
    modalActions.closeModal('ArchiveAllTicketModal');
  }, [modalActions]);

  const handleCancelModal = useCallback(() => {
    handleCloseModal();
  }, [handleCloseModal]);

  const handleSubmitForm = useCallback(
    (data: TArchiveAllTicketValidation) => {
      mutationArchiveAllTicket.mutate({
        spaceColumnId: data?.spaceColumnId,
      });
    },
    [mutationArchiveAllTicket]
  );

  return {
    // FORM
    form,
    isOpen,
    isDisabledForm,
    isLoadingForm,

    // HANDLERS
    handleCancelModal,
    handleCloseModal,
    handleSubmitForm,
  };
}
